import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const ZoomOutGlyph = /*#__PURE__*/createElement("g", {
  id: "zoomOut"
}, /*#__PURE__*/createElement("path", {
  d: "M68.61 66.45l-16.8-16.8c3.2-3.7 5.1-8.5 5.1-13.7 0-11.5-9.4-20.9-20.9-20.9s-21 9.4-21 20.9 9.4 20.9 20.9 20.9c5.2 0 10-1.9 13.7-5.1l16.8 16.8c.3.3.7.4 1.1.4.4 0 .8-.1 1.1-.4.5-.5.5-1.5 0-2.1zm-50.6-30.5c0-9.9 8-17.9 17.9-17.9s17.9 8 17.9 17.9-8 17.9-17.9 17.9-17.9-8-17.9-17.9z"
}), /*#__PURE__*/createElement("path", {
  d: "M45.35 37.45H26.48c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5h18.87c.83 0 1.5.67 1.5 1.5s-.68 1.5-1.5 1.5z"
}));
const ZoomOut = createSvg({
  name: 'zoomOut',
  path: ZoomOutGlyph
});

export default ZoomOut;
export { ZoomOutGlyph };
